const COLORS = ['#7F8AB3', '#e59425', '#4943FF', '#FF6100', '#FF6100', '#FE4485', '#02AA5A', '#02AA5A', '#7843FF', '#FF003F', '#FF003F', '#2B9DBD', '#0096FF', '#0096FF'];

const SCORE_TYPE = [{ prop: 'Eavl', label: 'pc_gwnl_eval_self_eval' }, { prop: 'Training', label: 'pc_gwnl_eval_selfTest' }, { prop: 'HimEavl', label: 'pc_gwnl_chart_type_peerLevel' }];

const EVAL_TYPE = [{ prop: 'before', label: 'pc_gwnl_training_catalog_before', count: 1 }, { prop: 'after', label: 'pc_gwnl_training_catalog_after', count: 3 }];
import { getTrainingModel } from '../service';

export default {
  data() {
    return {
      supportType: ['99'],
      classifyType: ['99'],
      loading: true,
      trainingSkill: {}
    };
  },
  computed: {
    allFields() {
      const allTypes = [
        {
          name: 'combStandardLevel',
          label: this.$t('pc_gwnl_chart_legend_standardLevel'),
          id: '99',
          props: {
            hoverLevelProp: 'standardLevelName',
            hoverValueProp: 'standardLevel'
          },
          show: true
        },
        {
          name: 'excellentEavl',
          label: this.$t('pc_gwnl_f2f_mark_excellent'),
          id: '98',
          props: {
            hoverLevelProp: 'combExcellentLevelName',
            hoverValueProp: 'excellentScore'
          },
          show: true
        }
      ];
      EVAL_TYPE.forEach((evalType, index) => {
        for (let evalIndex = 0; evalIndex < evalType.count; evalIndex++) {
          allTypes.push(SCORE_TYPE.map((scoreType, scoreIndex) => {
            const filedNameProp = evalType.prop + (evalIndex === 0 ? scoreType.prop : evalIndex + 1 + scoreType.prop);
            return {
              name: filedNameProp,
              label: this.$t(evalType.label) + (evalIndex === 0 ? this.$t(scoreType.label) : this.$t('pc_gwnl_training_the_n_times', { n: evalIndex + 1 }) + this.$t(scoreType.label)),
              id: `${index + evalIndex}` + scoreIndex,
              show: true,
              props: {
                hoverLevelProp: filedNameProp === 'combStandardLevel' ? 'standardLevelName' : filedNameProp + 'LevelName',
                hoverValueProp: filedNameProp
              }
            };
          }));
        }
      });
      return allTypes.flat().map((types, index) => {
        return {
          ...types,
          color: COLORS[index]
        };
      });
    },
    fields() {
      return this.allFields.filter(field => this.supportType.indexOf(field.id) !== -1).map((item) => {
        return {
          ...item,
          disabled: this.classifyType.indexOf(item.id) === -1,
          selected: item.id === '99' ? (this.trainingSkill.enableSkillLevel === 1
            ? true
            : (this.classifyType.length === 1 && this.classifyType[0] === '99')) // 无等级模型，只有无测评数据时才显示虚线雷达图
            : this.classifyType.indexOf(item.id) !== -1,
          show: item.id === '99' ? this.trainingSkill.enableSkillLevel === 1 &&
               (this.trainingSkill.showSkillLevel === 0 || (this.trainingSkill.showSkillLevel === 1 && this.classifyType.length > 1)) // showSkillLevel 测评完成前不显示标准(0-关闭,1-开启)
            : item.show
        };
      });
    }
  },
  mounted() {
    this.getProjectModel();
  },
  methods: {
    // 获取培训模型
    getProjectModel() {
      getTrainingModel(this.modelId, {
        evaluationList: this.evaluationList
      }).then(res => {
        this.trainingSkill = res;
        this.classifyType = res.classifyType.length === 0 ? ['99'] : res.classifyType;
        this.supportType = res.supportType || [];
        this.$emit('loadedData', 'skillTrendLoad');
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
